import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar, ArrowRight, BookOpen } from 'lucide-react';
import { getLatestBlogPosts } from '@/data/blogPosts';
export const BlogPreview: React.FC = () => {
  const latestPosts = getLatestBlogPosts(3);
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };
  return <section className="bg-primary-light/30 py-[70px]">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-4">
              <BookOpen className="h-8 w-8 text-primary mr-3" />
              <h2 className="text-3xl md:text-4xl font-bold text-foreground">
                Latest Articles
              </h2>
            </div>
            <p className="text-xl text-muted-foreground mb-8">
              Expert insights on life insurance and financial planning
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {latestPosts.map(post => <Card key={post.slug} className="hover:shadow-lg transition-shadow duration-300 flex flex-col h-full">
                {post.featuredImage && <div className="w-full aspect-video rounded-t-lg overflow-hidden">
                    <img src={post.featuredImage} alt={post.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" />
                  </div>}
                <CardHeader className="flex-shrink-0">
                  <div className="flex items-center text-sm text-muted-foreground mb-3">
                    <Calendar className="h-4 w-4 mr-1" />
                    {formatDate(post.publishDate)}
                  </div>
                  <CardTitle className="text-lg font-semibold text-foreground hover:text-primary transition-colors line-clamp-2">
                    <Link to={`/blog/${post.slug}`}>
                      {post.title}
                    </Link>
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow flex flex-col justify-between">
                  <p className="text-muted-foreground text-sm mb-4 flex-grow line-clamp-3">
                    {post.excerpt}
                  </p>
                  <Link to={`/blog/${post.slug}`} className="inline-flex items-center text-primary text-sm font-medium hover:underline mt-4">
                    Read More about {post.title}
                    <ArrowRight className="ml-1 h-4 w-4" />
                  </Link>
                </CardContent>
              </Card>)}
          </div>
          
          <div className="text-center">
            <Link to="/blog">
              <button className="inline-flex items-center px-6 py-3 bg-background text-foreground border border-border rounded-lg hover:bg-accent transition-colors font-medium">
                View All Articles
                <ArrowRight className="ml-2 h-4 w-4" />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
};